import * as React from 'react';
import { ColumnProps } from 'primereact/column';

import { ApproverEditColumnProps } from "./ApproverEditColumnProps";
import { ConfirmButton } from "./ConfirmButton";
import { ProjectDocFolderCUser } from '../../../../workflows/models/ProjectDocFolderCUser';


const EditorBody: React.FC<ApproverEditColumnProps> = ({ row, getEditable, onSave, onEditableChanged, onDelete }) => {
  const editable: boolean = getEditable(row);

  return row?.Id ?
    (
      <div className="d-flex">
        <ConfirmButton
          label=""
          icon="fas fa-exclamation-circle"
          message={`Вы уверены, что хотите удалить ${row?.User?.Title}?`}
          disabled={false}
          action={() => onDelete(row)} />
        {editable && (
          <button className="notif-action-btn notif-action-success" onClick={() => onSave(row)}>
            <i className="fa fa-check" />
          </button>
        )}
        {editable && (
          <button className="notif-action-btn" onClick={() => onEditableChanged(row, false)}>
            <i className="fa fa-times" />
          </button>
        )}
        {!editable && (
          <button className="notif-action-btn" onClick={() => onEditableChanged(row, true)}>
            <i className="fas fa-pencil-alt" />
          </button>
        )}
      </div>
    )
    :
    (
      <button className="notif-action-btn notif-action-success" onClick={() => onSave(row)}>
        <i className="fa fa-save" />
      </button>
    );
}

interface EditorHeaderProps {
  hasNewRow: boolean;
  onAddRow: () => void;
}

const EditorHeader: React.FC<EditorHeaderProps> = ({ hasNewRow, onAddRow }) => {
  return (
    <button className="notif-action-btn" onClick={onAddRow}>
      <i className={hasNewRow ? "fa fa-times" : "fa fa-plus"} />
    </button>
  );
}

export function ApproverEditColumn(
  hasNewRow: boolean,
  getEditable: (row: ProjectDocFolderCUser) => boolean,
  onAddRow: () => void,
  onSave: (row: ProjectDocFolderCUser) => void,
  onEditableChanged: (row: ProjectDocFolderCUser, editable: boolean) => void,
  onDelete: (item: ProjectDocFolderCUser) => void
): ColumnProps {
  return {
    header: <EditorHeader hasNewRow={hasNewRow} onAddRow={onAddRow} />,
    headerStyle: { width: "5rem" },
    body: (row: ProjectDocFolderCUser) => <EditorBody row={row} getEditable={getEditable} onSave={onSave} onEditableChanged={onEditableChanged} onDelete={onDelete} />,
    filter: false,
    sortable: false
  };
}
